export const experimentDomain = "https://stackoverflow.com";
export const experimentFlag = "growth-experiment-cookie-banner-enabled";
export const cookieBannerExperimentStorageKey = "cookie_banner_experiment_run";
